const hyphenToCamelCase = hyphenBasedString => {
  return hyphenBasedString.replace(/-([a-z])/g, function(g) {
    return g[1].toUpperCase();
  });
};

export default hyphenToCamelCase;
